export function crop(text: string, len = 160) {
  if (text.length <= len) {
    return text;
  }
  return text.slice(0, len) + "...";
}

export function numerize(num: number, singular: string, plural: string) {
  if (num === 11) {
    return `${num} ${plural}`;
  }

  const lastDigit = num % 10;

  if (lastDigit === 1) {
    return `${num} ${singular}`;
  }

  return `${num} ${plural}`;
}
